import React from "react";
import { Link } from "react-router";
import values from "lodash/values";
import pick from "lodash/pickBy";
import { RadioButton, RadioButtonGroup, RaisedButton } from "material-ui";

import connectToStores from "alt-utils/lib/connectToStores";
import TitleActions from "../actions/TitleActions";
import TitleStore from "../stores/TitleStore";
import TitleUtil from "../utils/TitleUtil";
import VirtualContentStore from "../stores/VirtualContentStore";
import VirtualContentActions from "../actions/VirtualContentActions";

import config from "../config";
import UserStore from "../stores/UserStore";

import WorkingIndicator from "./partials/working-indicator.jsx";
import { TitleDeliveryStatus } from "./partials/film-table.jsx";

import qs from "query-string";

const parsedQueryString = qs.parse(window.location.search);

class TitleDelivery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSaving: false,

      hasExistingPrint: null,
      existingPrintDeliveryMethod: null,
      virtualDeliveryMethod: null
    };
  }

  static getStores() {
    return [UserStore, TitleStore, VirtualContentStore];
  }

  static getPropsFromStores() {
    return TitleStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  saveDeliveryDetails() {
    this.setState({ isSaving: true });
    TitleUtil.editTitleDelivery(
      UserStore.getState().apiKey,
      this.props.params.titleDeliveryId,
      {
        print_delivery_type:
          this.state.hasExistingPrint === false
            ? "new_order"
            : this.state.existingPrintDeliveryMethod,
        virtual_delivery_type: this.state.virtualDeliveryMethod
      }
    )
      .then(data => {
        // Re-fetch after saving
        TitleActions.fetchOne(this.props.params.titleId);
        this.setState({ isSaving: false }, () => {
          window.scrollTo(0, 0);
        });
      })
      .catch(e => {
        window.alert(`Failed to save details: ${e.message}`);
        this.setState({ isSaving: false });
      });
  }

  _injectUrl(url, title, titleDelivery) {
    const account = UserStore.getAccount() || {};
    const values = {
      title_name: title.name,
      creator_email: account.email,
      creator_name: account.name,
      delivery_identifier: `${titleDelivery.receiving_event_bucket.name}`
    };
    return url.replace(/{{(.*?)}}/g, (_, key) => {
      const value = values[key];
      return encodeURIComponent(value);
    });
  }

  _makeQuotePrintLink(title, titleDelivery) {
    return this._injectUrl(
      titleDelivery.print_quote_portal_url || "",
      title,
      titleDelivery
    );
  }

  _makeUploadPrintLink(title, titleDelivery) {
    return this._injectUrl(
      titleDelivery.print_upload_portal_url || "",
      title,
      titleDelivery
    );
  }

  _makeUploadVirtualLink() {
    const title = TitleStore.getTitleById(this.props.params.titleId),
      titleDelivery =
        title &&
        title.title_deliveries.find(
          d => d.id === this.props.params.titleDeliveryId
        );
    return `/creator_hub/films/${titleDelivery.receiving_film.id}`;
  }

  getStyles() {
    return {
      container: {
        maxWidth: 500,
        margin: "5% auto",
        fontSize: "11pt",
        padding: "5px 20px",
        borderRadius: "1em",
        boxShadow: "0 0 20px 2px rgba(0,0,0,0.2)"
      },
      header: {
        fontWeight: "bold",
        fontSize: "14pt",
        marginTop: "1em",
        marginBottom: "-0.25em"
      },
      radio: {
        marginTop: "0.5em",
        fontSize: "0.9em"
      }
    };
  }

  componentWillMount() {
    TitleActions.fetchOne(this.props.params.titleId);
    VirtualContentActions.fetchAll();
  }

  render() {
    const styles = this.getStyles(),
      title = TitleStore.getTitleById(this.props.params.titleId),
      titleDelivery =
        title &&
        title.title_deliveries.find(
          d => d.id === this.props.params.titleDeliveryId
        );

    if (!title || !titleDelivery || this.props.isFetching) {
      return <WorkingIndicator fullPage={true} />;
    }

    const needsPrint =
      titleDelivery.receiving_film.title_requested_media.includes("print");
    const needsVirtual =
      titleDelivery.receiving_film.title_requested_media.includes("virtual");

    const isDigitalFile =
      titleDelivery.accepted_print_formats &&
      titleDelivery.accepted_print_formats.includes("digital_file");

    const canSave =
        (needsPrint
          ? ((isDigitalFile || this.state.hasExistingPrint === true) &&
              this.state.existingPrintDeliveryMethod) ||
            this.state.hasExistingPrint === false
          : true) &&
        (needsVirtual && needsPrint
          ? isDigitalFile || this.state.virtualDeliveryMethod
          : true),
      canEnterVirtual = needsPrint
        ? isDigitalFile
          ? this.state.existingPrintDeliveryMethod
          : this.state.hasExistingPrint !== null
        : true;

    return (
      <div style={styles.container}>
        <div
          style={{
            textAlign: "center",
            fontSize: "1.25em",
            margin: "1em 0"
          }}
        >
          <span style={{ fontFamily: "monospace, sans-serif" }}>
            {titleDelivery.delivery_identifier}
          </span>{" "}
          &middot; <TitleDeliveryStatus title_delivery={titleDelivery} />
        </div>
        {titleDelivery.status_description ? (
          <div
            style={{
              textAlign: "center",
              fontSize: "1em",
              marginTop: "-0.5em",
              marginBottom: "1em",
              fontStyle: "italic",
              color: "rgb(229, 57, 53)",
              border: "1px solid rgb(229, 57, 53)",
              borderRadius: "0.25em",
              padding: 5
            }}
          >
            {titleDelivery.status_description}
          </div>
        ) : null}
        <p>
          Welcome! Eventive
          {needsPrint ? `, in partnership with Simple DCP,` : ""} is here to
          assist you in delivering <strong>{title.name}</strong> to{" "}
          <strong>{titleDelivery.receiving_event_bucket.name}</strong>, hosted
          by <strong>{titleDelivery.receiving_user.organization}</strong>.
        </p>
        <p>
          You can track this delivery using the unique identifier{" "}
          <span
            style={{
              fontFamily: "monospace, sans-serif",
              whiteSpace: "nowrap"
            }}
          >
            {titleDelivery.delivery_identifier}
          </span>
          . Provide this identifier to ensure accurate support.
        </p>
        {titleDelivery.status === "draft" ? (
          <div>
            <h2 style={styles.header}>Requested assets</h2>
            <p>The following assets are requested for this title.</p>
            <ul style={{ marginTop: "-0.5em" }}>
              {titleDelivery.receiving_film.title_requested_media
                .sort()
                .map(media => (
                  <li>
                    {media === "virtual"
                      ? "Virtual screening asset"
                      : media === "print"
                      ? isDigitalFile
                        ? "Digital file (non-DCP)"
                        : "Print (DCP)"
                      : "?"}
                  </li>
                ))}
            </ul>
            {titleDelivery.receiving_film.title_requested_media.includes(
              "print"
            ) ? (
              isDigitalFile ? (
                <div>
                  <h2 style={styles.header}>Digital file (non-DCP) delivery</h2>
                  <p>
                    How would you like to deliver your non-DCP digital file for
                    exhibition?
                    <RadioButtonGroup
                      style={styles.radio}
                      name="existingPrintDeliveryMethod"
                      valueSelected={this.state.existingPrintDeliveryMethod}
                      onChange={(e, v) =>
                        this.setState({
                          existingPrintDeliveryMethod: v,
                          virtualDeliveryMethod: needsVirtual
                            ? "direct_upload"
                            : null
                        })
                      }
                    >
                      <RadioButton
                        value={"upload_asset"}
                        label="Upload digital file via web portal"
                      />
                      <RadioButton
                        value={"on_file"}
                        label="Use digital file on file with Simple DCP"
                      />
                    </RadioButtonGroup>
                  </p>
                </div>
              ) : (
                <div>
                  <h2 style={styles.header}>Print delivery</h2>
                  <p>
                    Do you have an exhibition print of {title.name} available to
                    deliver to {titleDelivery.receiving_user.organization}?
                    <RadioButtonGroup
                      style={styles.radio}
                      name="hasExistingPrint"
                      valueSelected={this.state.hasExistingPrint}
                      onChange={(e, v) =>
                        this.setState({ hasExistingPrint: v })
                      }
                    >
                      <RadioButton
                        value={true}
                        label={`Yes, I have an exhibition print (DCP) available`}
                      />
                      <RadioButton
                        value={false}
                        label="No, I need to have an exhibition print made"
                      />
                    </RadioButtonGroup>
                  </p>
                  {this.state.hasExistingPrint === true ? (
                    <div
                      style={{
                        fontSize: "0.75em",
                        marginTop: "0em",
                        lineHeight: "1.25em",
                        fontStyle: "italic"
                      }}
                    >
                      Note: The exhibition systems in use at this festival are
                      known to be incompatible with DCPs made using the Quvis
                      Wraptor Plugin for Adobe products. DCPs found to be
                      created using this software will be summarily rejected.
                    </div>
                  ) : null}
                  {this.state.hasExistingPrint === true ? (
                    <p>
                      How would you like to deliver your existing print?
                      <RadioButtonGroup
                        style={styles.radio}
                        name="existingPrintDeliveryMethod"
                        valueSelected={this.state.existingPrintDeliveryMethod}
                        onChange={(e, v) =>
                          this.setState({ existingPrintDeliveryMethod: v })
                        }
                      >
                        <RadioButton
                          value={"upload_asset"}
                          label="Upload via web portal"
                        />
                        {/* <RadioButton
                    value={"send_link"}
                    label="Provide download link"
                  /> */}
                        <RadioButton
                          value={"mail_asset"}
                          label="Mail physical drive"
                        />
                        <RadioButton
                          value={"on_file"}
                          label="Use print on file with Simple DCP"
                        />
                      </RadioButtonGroup>
                    </p>
                  ) : this.state.hasExistingPrint === false ? (
                    <p>
                      Got it. In the next step, our recommended vendor, Simple
                      DCP, will provide an instant quote.
                    </p>
                  ) : null}
                </div>
              )
            ) : null}
            {titleDelivery.receiving_film.title_requested_media.includes(
              "virtual"
            ) ? (
              <div>
                <h2 style={styles.header}>Virtual screening asset delivery</h2>
                {!canEnterVirtual ? (
                  <p style={{ fontStyle: "italic" }}>
                    Please answer all questions above about your{" "}
                    {isDigitalFile ? "digital file" : "print"} delivery.
                  </p>
                ) : (
                  <div>
                    {needsPrint && !isDigitalFile ? (
                      <p>
                        How would you like to deliver your virtual screening
                        asset?
                        <RadioButtonGroup
                          style={styles.radio}
                          name="virtualDeliveryMethod"
                          valueSelected={this.state.virtualDeliveryMethod}
                          onChange={(e, v) =>
                            this.setState({ virtualDeliveryMethod: v })
                          }
                        >
                          <RadioButton
                            value={"direct_upload"}
                            label="Manually upload a virtual screening asset"
                          />
                          <RadioButton
                            value={"extract_from_print"}
                            label="Extract and create virtual asset from exhibition print"
                          />
                        </RadioButtonGroup>
                      </p>
                    ) : (
                      <p>
                        In the next step, you can upload your virtual screening
                        asset.
                      </p>
                    )}
                  </div>
                )}
              </div>
            ) : null}
            <h2 style={styles.header}>Confirm and save</h2>
            {!canSave ? (
              <p style={{ fontStyle: "italic" }}>
                Please answer all questions above about your delivery.
              </p>
            ) : needsPrint ? (
              <p>
                Please review your answers above, as they cannot be modified
                after you click save. When you are ready to proceed to delivery,
                please save and continue.
              </p>
            ) : (
              <p>We will initiate a new upload session for your asset.</p>
            )}
            <RaisedButton
              label={
                this.state.isSaving
                  ? "Saving delivery details..."
                  : "Save delivery details & continue"
              }
              style={{ marginBottom: "1.5em" }}
              disabled={!canSave || this.state.isSaving}
              primary={true}
              onTouchTap={() => {
                if (needsVirtual && !needsPrint) {
                  // Virtual only - short circuit as always direct upload
                  this.setState(
                    { virtualDeliveryMethod: "direct_upload" },
                    () => {
                      this.saveDeliveryDetails();
                    }
                  );
                } else {
                  this.saveDeliveryDetails();
                }
              }}
            />
          </div>
        ) : (
          <div style={{ marginBottom: "1.5em" }}>
            {titleDelivery.print_delivery_type ? (
              <p>
                <strong>
                  {isDigitalFile ? "Digital file delivery" : "Print delivery"}
                </strong>
                : You have indicated that you{" "}
                {titleDelivery.print_delivery_type === "new_order"
                  ? "need to have an exhibition print made. Please click below to request a quote. Simple DCP will handle the process from there."
                  : titleDelivery.print_delivery_type === "upload_asset"
                  ? `will upload your ${
                      isDigitalFile
                        ? "exhibition-quality digital file (non-DCP)"
                        : "DCP"
                    } directly. Please utilize the uploader below.`
                  : titleDelivery.print_delivery_type === "on_file"
                  ? "already have a print on file with Simple DCP. We will attempt to pull this print from archive, and contact you if there are any issues."
                  : titleDelivery.print_delivery_type === "mail_asset"
                  ? `will deliver your DCP by mail. ${
                      titleDelivery.print_mail_instructions ||
                      "Please contact the festival for further instructions."
                    }`
                  : "?."}
              </p>
            ) : null}
            {titleDelivery.print_delivery_type === "new_order" ? (
              <div>
                <RaisedButton
                  label="Request DCP quote"
                  primary={true}
                  href={this._makeQuotePrintLink(title, titleDelivery)}
                  target="_blank"
                />
              </div>
            ) : titleDelivery.print_delivery_type === "upload_asset" ? (
              <div>
                <RaisedButton
                  label={`Launch ${
                    isDigitalFile ? "digital file" : "DCP"
                  } upload portal`}
                  primary={true}
                  href={this._makeUploadPrintLink(title, titleDelivery)}
                  target="_blank"
                />
              </div>
            ) : null}
            {titleDelivery.virtual_delivery_type ? (
              <p>
                <strong>Virtual delivery</strong>: You have{" "}
                {titleDelivery.virtual_delivery_type === "extract_from_print"
                  ? "requested that we extract and prepare your virtual screening asset using the print asset that you deliver. No additional action is necessary."
                  : "indicated that you will upload a virtual screening asset. Please upload this asset below."}
              </p>
            ) : null}
            {titleDelivery.virtual_delivery_type === "direct_upload" ? (
              <div>
                <RaisedButton
                  label="Upload virtual content"
                  primary={true}
                  href={this._makeUploadVirtualLink({})}
                  target="_blank"
                />
              </div>
            ) : null}
            <div
              style={{
                marginTop: "1.5em",
                borderTop: "1px solid #ccc",
                paddingTop: "1.5em"
              }}
            >
              <strong>What's next?</strong> We will review your submitted
              materials promptly upon receipt. As your delivery is processed, or
              if there are any questions or issues, we will keep you informed
              via email to {UserStore.getAccount().email}.
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connectToStores(TitleDelivery);



// WEBPACK FOOTER //
// ./src/app/components/creator-title-delivery.jsx